import { createTheme } from '@mui/material/styles'
import type { } from '@mui/x-date-pickers/themeAugmentation';

export const breakpoints = {
  xs: 0,
  sm: 544,
  md: 768,
  lg: 992,
  xl: 1600
};

/** @todo избавиться. переписать на css container queries */
export const leftMenuSmallWidth = '72px';
export const leftMenuLargeWidth = '256px';

export const muiTheme = createTheme({
  breakpoints: {
    values: breakpoints,
  },

  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },

      styleOverrides: {
        root: ({ theme }) => ({
          padding: '8px 16px 4px',
          textAlign: 'center',
        }),
        sizeSmall: {
          padding: '5px 10px 3px'
        },
        text: ({ theme, ownerState }) => ({
          padding: '8px 8px 4px',
          color: theme.palette[ownerState.color === 'secondary' ? 'secondary' : 'primary'].main,
          '&:hover': {
            backgroundColor: 'rgba(0,0,0, 0.05)',
          },
        }),
        textSizeSmall: {
          padding: '5px 5px 3px'
        },
        outlined: {
          padding: '7px 15px 3px',
        },
        outlinedSizeSmall: {
          padding: '4px 9px 2px'
        },
        startIcon: {
          marginTop: '-4px',
        },
        endIcon: {
          marginTop: '-4px',
        },
        iconSizeSmall: {
          marginTop: '-2px',
        },
      },

      variants: [
        {
          props: { variant: 'contained', color: 'info' },
          style: ({ theme }) => ({
            background: '#f2f2f2',
            color: theme.palette.primary.main,
            ':hover': {
              background: '#e8e8e8',
            },
          }),
        },
      ],
    },

    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottomColor: 'rgba(0,0,0, 0.12)',
          },
          '&:hover:not(.Mui-disabled):before': {
            borderBottomColor: 'rgba(0,0,0, 0.24)',
            '@media (hover: none)': {
              borderBottomColor: 'rgba(0,0,0, 0.12)',
            },
          },
          '&.Mui-disabled:before': {
            borderBottomColor: 'rgba(35, 31, 32, 0.26)',
            borderBottomStyle: 'dotted',
          },
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'rgba(0,0,0, 0.54)',
        },
      },
    },

    MuiListItemButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-selected': {
            backgroundColor: theme.palette.background.selected,

            ':hover': {
              backgroundColor: theme.palette.background.selected,
            },
          },
        }),
      },
    },

    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 36
        }
      },
    },

    MuiListItemText: {
      styleOverrides: {
        root: {
          color: 'rgba(0,0,0,0.87)'
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.paper,
          backgroundImage: 'unset',
        }),
      },
    },

    MuiPickersInput: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&:before': {
            borderBottomColor: theme.palette.action.disabledBackground,
          },
          '&:hover:not(.Mui-disabled, .Mui-error):before': {
            borderBottomColor: theme.palette.action.disabled,
          }
        }),

        underline: {
          '&:before': {
            borderBottomColor: 'rgba(0,0,0, 0.12)',
          },
          '&:hover:not(.Mui-disabled):before': {
            borderBottomColor: 'rgba(0,0,0, 0.24)',
            '@media (hover: none)': {
              borderBottomColor: 'rgba(0,0,0, 0.12)',
            },
          },
          '&.Mui-disabled:before': {
            borderBottomColor: 'rgba(35, 31, 32, 0.26)',
            borderBottomStyle: 'dotted',
          },
        },
      }
    },

    MuiPickersTextField: {
      defaultProps: {
        variant: 'standard',
      },
      styleOverrides: {
        root: {
          maxWidth: '100%',
        },
      },
    },

    MuiTab: {
      styleOverrides: {
        root: ({ theme }) => ({
          textTransform: 'initial',
          fontSize: '16px',
          fontWeight: '400',
          letterSpacing: '0',
          color: theme.palette.text.primary,
          minWidth: '100px',
        }),
        textColorSecondary: {
          color: 'inherit',
        },
      }
    },

    MuiTableCell: {
      styleOverrides: {
        sizeSmall: {
          paddingTop: '4px',
          paddingBottom: '4px',
        },
      },
    },

    MuiTableRow: {
      styleOverrides: {
        root: {
          '&.MuiTableRow-hover:hover': {
            background: '#cfecf3',
          }
        },
      },
    },

    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
  },

  palette: {
    background: {
      selected: 'rgba(0,0,0,0.08)',
    },
    primary: {
      main: '#00A6EB',
      dark: '#33b7ef',
      light: '#0074a4',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#ff5d3d',
    },
    text: {
      disabled: 'rgba(0,0,0, 0.54)',
    },
  },

  typography: {
    fontFamily: 'DINWebPro, Barlow, Calibri, "Segoe UI", "Open Sans", Helvetica, sans-serif',
    h1: {
      fontSize: '6rem',
      lineHeight: '1.29',
      fontWeight: '350',
      letterSpacing: '-0.015625em',
    },
    h2: {
      fontSize: '3.75rem',
      lineHeight: '1.28',
      fontWeight: '350',
      letterSpacing: '-0.008333em',
    },
    h3: {
      fontSize: '3rem',
      lineHeight: '1.29',
      fontWeight: 'normal',
    },
    h4: {
      fontSize: '2.125rem',
      lineHeight: '1.29',
      fontWeight: 'normal',
      letterSpacing: '0.007353em',
    },
    h5: {
      fontSize: '1.5rem',
      lineHeight: '1.29',
      fontWeight: 'normal',
    },
    h6: {
      fontSize: '1.25rem',
      lineHeight: '1.4',
      fontWeight: 'normal',
      letterSpacing: '0.0075em',
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 'normal',
      lineHeight: '1.25',
    },
    body2: {
      fontSize: '0.875rem',
      fontWeight: 'normal',
      lineHeight: '1.43',
      letterSpacing: '0.017857em',
    },
    subtitle1: {
      fontSize: '1rem',
      fontWeight: 'normal',
      lineHeight: '1.25',
      letterSpacing: '0.009375em',
    },
    subtitle2: {
      fontSize: '0.875rem',
      fontWeight: '500',
      lineHeight: '1.43',
      letterSpacing: '0.007143em',
    },
    button: {
      fontSize: '0.875rem',
      fontWeight: '500',
      letterSpacing: '0.089286em',
      textTransform: 'uppercase',
    },
    caption: {
      fontSize: '0.75rem',
      fontWeight: '500',
      lineHeight: '1.333',
      letterSpacing: '0.033333em',
    },
    overline: {
      fontSize: '0.625em',
      fontWeight: '500',
      lineHeight: '2',
      letterSpacing: '0.15em',
      textTransform: 'uppercase',
    },
  },
});
